import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { map } from 'rxjs/operators';
import { ReferralService } from '../services/referral.service'
import { LoginService } from '../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { QueryParamsModel } from '../models/query-params.model';
import { state } from '@angular/animations';
@Component({
  selector: 'app-login-with-otp',
  templateUrl: './login-with-otp.component.html',
  styleUrls: ['./login-with-otp.component.css']
})
export class LoginWithOtpComponent implements OnInit {
  showError: boolean = false;
  isRequired: boolean = false;
  hide = true;
  loading = false;
  referralCode='';
  constructor(
    private router: Router,
    private referralService: ReferralService,
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
  }
  validateReferralCode(referralCode) {
    let refrral = referralCode;
    this.loading = true;
    if (!referralCode) {
      this.isRequired = true;
      this.showError = false;
      this.loading = false;
      return;
    }
    this.isRequired = false;
    this.loginService.validateReferralCode(referralCode)
      .subscribe(
        result => {
          this.toastr.success('OTP Has Sent To Your Email');
          localStorage.setItem('responseData', JSON.stringify(result))
          localStorage.setItem('referral', (refrral))
          this.router.navigate(['/otp']);
          this.loading = false;
        },
        error => {
          if (error.error.Status === 404||422) {
            this.showError = true;
            this.loading = false;
            this.toastr.error(error.error.Message)
          }
        },
        () => {
        }
      );
  }
  valuechange(newValue) {
    this.showError = false;
    this.isRequired = false;
  }
  signup() {
    
  }
  forgotReferral() {
    this.router.navigate(["forgot-referral"])
  }
}
